"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateSelectedOption = void 0;
const react_1 = require("react");
const isSelected = (opt) => !!opt.selected;
const useUpdateSelectedOption = (options, setSelectedOption) => {
    const optionsRef = (0, react_1.useRef)(options);
    (0, react_1.useEffect)(() => {
        if (JSON.stringify(optionsRef.current) !== JSON.stringify(options)) {
            setSelectedOption(options.findIndex(isSelected));
            optionsRef.current = options;
        }
    }, [options]);
};
exports.useUpdateSelectedOption = useUpdateSelectedOption;
//# sourceMappingURL=useUpdateSelectedOption.js.map